module.exports = __webpack_public_path__ + "media/images/ITR@2x-cd44077d580015e471bd60ca06423104.png";